
import { SlideOverCustomization } from "hooks/slideOver";
import { SlideOverContext } from "@notanumber/nan-component-library";
import { useContext, useMemo, useState } from "react";
import { printHTML } from "hooks/utils/formatter";
import { faFilter } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ProductFilter from "components/General/CategoryElements/ProductFilters/ProductFilters";
import ProductCard from "components/General/ProductCard/ProductCard";
import CategoryFilters from "components/General/CategoryElements/CategoryFilters/CategoryFilters";
import { Pagination } from "flowbite-react";
import { faArrowLeft, faArrowRight } from "@fortawesome/pro-solid-svg-icons";

const CategoryPageLayout = ({ title, description, active_cat, categories, filters, selectedFilters, setSelectedFilters, products, is_search = false }) => {
  const { setSlideOver } = useContext(SlideOverContext);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 60;

  const postPerPagination = useMemo(() => {
    if (!products) return;

    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    return products?.slice(start, end);
  }, [products, currentPage]);

  const totalPages = Math.ceil((products?.length || 0) / itemsPerPage);
  const results = postPerPagination?.length || 0;

  // Logic for product count text (1 resultaat, 2-xx resultaten, geen resultaten)
  function getProductCountContent() {
    if (results < 1) return "Geen resultaten";
    if (results === 1) return "1 resultaat";

    const start = (currentPage - 1) * itemsPerPage + 1;
    const end = start + results - 1;
    return `${start} - ${end} resultaten van ${products?.length || 0}`;
  }

  const productCountTxt = getProductCountContent();

  return (
    <div className="px-4 mx-auto mb-16 max-w-app xl:px-0">
      <h1 className="mb-3">{title}</h1>
      <div className="mb-4 lg:grid lg:grid-cols-4 lg:gap-x-10">
        <button
          className="flex items-center justify-between w-full h-8 px-4 text-white lg:hidden font-sm md:text-15 lg:font-bold bg-dark-bg rounded-5"
          onClick={() => {
            setSlideOver(
              <div className="w-[calc(100vw-1.5rem)] px-8 md:w-[37.5rem]]">
                <h3 className="mb-4 text-xl">Filters</h3>
                <CategoryFilters
                  categories={categories}
                  active_id={active_cat}
                />
                {!is_search && (
                  <div className="mt-3">
                    {filters?.map((filter) => {
                      if (!filter?.terms?.length) return null;

                      return (
                        <ProductFilter
                          key={filter?.slug}
                          label={filter?.display_name}
                          options={filter?.terms || []}
                          selected={selectedFilters[filter?.slug] || []}
                          setSelected={(arr) =>
                            setSelectedFilters((prev) => ({
                              ...prev,
                              [filter?.slug]: arr,
                            }))
                          }
                        />
                      )
                    })}
                  </div>
                )}
              </div>,
              SlideOverCustomization
            );
          }}
        >
          <div className="flex justify-start flex-1 lg:hidden">
            <FontAwesomeIcon
              icon={faFilter}
              className="w-auto h-4"
            />
          </div>
          <div className="text-dark-bg-text">{productCountTxt}</div>
          <div className="flex-1 lg:hidden"></div>
        </button>

        <div className="items-center justify-start hidden col-start-2 lg:flex font-sm md:text-15">
          <div className="text-dark-text">{productCountTxt}</div>
        </div>
      </div>
      <div className="lg:grid lg:grid-cols-4 gap-x-6">
        <div className="hidden w-full lg:block lg:col-span-1">
          <CategoryFilters
            categories={categories}
            active_id={active_cat}
          />
          {!is_search && (
            <div className="mt-4">
              {filters?.map((filter) => {
                if (!filter?.terms?.length) return null;

                return (
                  <ProductFilter
                    key={filter?.slug}
                    label={filter?.display_name}
                    options={filter?.terms || []}
                    selected={selectedFilters[filter?.slug] || []}
                    setSelected={(arr) =>
                      setSelectedFilters((prev) => ({
                        ...prev,
                        [filter?.slug]: arr,
                      }))
                    }
                  />
                )
              })}
            </div>
          )}
        </div>
        <div className="md:col-span-3 md:col-start-2">
          <div className="grid grid-cols-2 gap-x-6 gap-y-9 sm:gap-6 xl:grid-cols-3">
            {postPerPagination.length > 0 &&
                            postPerPagination.map((product, idx) => {
                              return (
                                <ProductCard
                                  product={product}
                                  key={idx}
                                />
                              );
                            })}
          </div>
        </div>
      </div>

      {totalPages > 1 && (
        <div className="my-14 lg:grid md:grid-cols-4 gap-x-10 pagination_overview">
          <div className="flex justify-center col-span-3 col-start-2">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              previousLabel={<FontAwesomeIcon icon={faArrowLeft} className="text-lg" />}
              nextLabel={<FontAwesomeIcon icon={faArrowRight} className="text-lg" />}
              onPageChange={(page) => {
                setCurrentPage(page);

                // Scroll to top of the page
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            />
          </div>
        </div>
      )}

      {(description && !is_search) && (
        <div className="mt-14 md:grid md:grid-cols-4 gap-x-10">
          <div className="col-span-3 col-start-2 p-6 bg-white md:py-16 md:px-20 rounded-10">
            {printHTML(description)}
          </div>
        </div>
      )}
    </div>
  );
}

export default CategoryPageLayout;